// extracted by mini-css-extract-plugin
export default {"container":"TimeDividers_container__gaTKH","text":"TimeDividers_text__lY9lh"};